import { useState } from "react";
import { FaEyeSlash } from "react-icons/fa";

import { EyeIcon } from "../../assets/Icons";
import { useDarkMode } from "../../context/DarkModeContext";
import { InputProps } from "./types";

export const Input = ({
  type = "text",
  placeholder,
  required = false,
  icon,
  register,
  name,
  className = "",
  isPassword = false,
  value,
  onChange,
}: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const darkMode = useDarkMode();
  const baseInputStyles =
    "w-full p-3 border rounded-lg pl-4 bg-white text-black dark:bg-black dark:text-white placeholder-gray-400 dark:placeholder-white focus:outline-none focus:ring-2 focus:ring-blue-500";
  const combinedClassName = `${baseInputStyles} ${className}`;
  const registration = register && name ? register(name) : undefined;

  return (
    <div className="relative">
      <input
        type={isPassword ? (showPassword ? "text" : "password") : type}
        placeholder={placeholder}
        {...(register && name ? register(name) : {})}
        className={combinedClassName}
        required={required}
        aria-label={placeholder}
        value={value ?? registration?.value}
        onChange={(e) => {
          registration?.onChange(e);
          onChange?.(e);
        }}
      />
      <div className="absolute top-1/2 right-3 transform -translate-y-1/2">
        {isPassword ? (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="focus:outline-none"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <EyeIcon theme={darkMode ? "dark" : "light"} />
            ) : (
              <FaEyeSlash className="text-gray-400 dark:text-white" />
            )}
          </button>
        ) : (
          icon && <div className="dark:text-white text-gray-400">{icon}</div>
        )}
      </div>
    </div>
  );
};
